import styled from '@emotion/styled'

export default styled.blockquote`
  line-height: 1.35;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: larger;
`
